export default "__VITE_ASSET__FJP1VPAj__"